import type ITagNewHook from "../types/ITagNewHook";
import useApi from "../services/api/hooks/useApi";
import { type Tag } from "../types/Tag";
import type ApiResponse from "../services/api/types/ApiResponse";
import Api from "../services/auth/types/IsaacApi";
import ApiHttpVerbs from "../services/api/types/ApiHttpVerbs";
import { useCallback } from "react";
import {type TagConstruction } from "../types/TagConstruction";

export const useTagNewHook = (): ITagNewHook => {
    const { fetchData } = useApi();

    const deleteTagFromConstruction = async (
        constructionId: string,
        tags: Tag[],
    ): Promise<ApiResponse<void>> => {
        const url = `${process.env.REACT_APP_ICC_API_URL}/constructions/${constructionId}/tags/`;
        const response = await fetchData<never>(
            url,
            Api.ICC,
            {useGlobalHandler: false},
            ApiHttpVerbs.DELETE,
            {},
            JSON.stringify(tags),
        );

        return response;
    };

    const addTagsToConstruction = async (
        constructionId: string,
        tags: Tag[],
    ): Promise<ApiResponse<Tag[]>> => {
        const url = `${process.env.REACT_APP_ICC_API_URL}/constructions/${constructionId}/tags/`;
    
        const response = await fetchData<Tag[]>(
          url,
          Api.ICC,
          {useGlobalHandler: false},
          ApiHttpVerbs.POST,
          {},
          JSON.stringify(tags),
        );
    
      return response;
    };

    const deleteTagsFromConstructions = async (
      ids: string[],
      tags: string[],
    ): Promise<Array<ApiResponse<void>>> => {
      const promises: Array<Promise<ApiResponse<void>>> = [];

      ids.forEach(id => {
        promises.push(
          deleteTagFromConstruction(
            id,
            tags.map(t => ({
              Value: t,
            })),
          ),
        );
      });

      return await Promise.all(promises);
    };

    const addTagsToConstructions = async (
      ids: string[],
      tags: string[],
    ): Promise<Array<ApiResponse<Tag[]>>> => {
      const promises: Array<Promise<ApiResponse<Tag[]>>> = [];

      ids.forEach(id => {
        promises.push(
          addTagsToConstruction(
            id,
            tags.map(t => ({
              Value: t,
            })),
          ),
        );
      });

      return await Promise.all(promises);
    };

     const getAllTags = useCallback(async (): Promise<
        ApiResponse<TagConstruction[] | null>
      > => {
        const url = `${process.env.REACT_APP_ICC_API_URL}/tags/`;
        const response = await fetchData<TagConstruction[]>(
          url,
          Api.ICC,
          {useGlobalHandler: false},
          ApiHttpVerbs.GET,
        );
    
        return response;
      }, [fetchData]);

    return {
      addTagsToConstruction,
      addTagsToConstructions,
      deleteTagFromConstruction,
      deleteTagsFromConstructions,
      getAllTags
    };
};

export default useTagNewHook;